"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AddSubjectsToReviewCycleMetadataSchema () {
        return AddSubjectsToReviewCycleMetadataSchema;
    },
    get BulkFeedbackMetadataSchema () {
        return BulkFeedbackMetadataSchema;
    },
    get BulkFeedbackRequestMetadataSchema () {
        return BulkFeedbackRequestMetadataSchema;
    },
    get CreateReviewCycleMetadataSchema () {
        return CreateReviewCycleMetadataSchema;
    },
    get ExportCompanyMeetingsMetadataSchema () {
        return ExportCompanyMeetingsMetadataSchema;
    },
    get ExportCompetencyAssignmentsMetadataSchema () {
        return ExportCompetencyAssignmentsMetadataSchema;
    },
    get ExportGoalsCsvMetadataSchema () {
        return ExportGoalsCsvMetadataSchema;
    },
    get ExportWorkspaceMeetingsMetadataSchema () {
        return ExportWorkspaceMeetingsMetadataSchema;
    },
    get FieldHistoryImportErrorSchema () {
        return FieldHistoryImportErrorSchema;
    },
    get GenerateReviewCycleInsightsMetadataSchema () {
        return GenerateReviewCycleInsightsMetadataSchema;
    },
    get GenerateSurveyInsightsMetadataSchema () {
        return GenerateSurveyInsightsMetadataSchema;
    },
    get ImportCompetencyDocumentMetadataSchema () {
        return ImportCompetencyDocumentMetadataSchema;
    },
    get ImportFieldHistoryMetadataSchema () {
        return ImportFieldHistoryMetadataSchema;
    },
    get ProcessDocumentEmbeddingsMetadataSchema () {
        return ProcessDocumentEmbeddingsMetadataSchema;
    },
    get RegenerateSyntheticEmailsMetadataSchema () {
        return RegenerateSyntheticEmailsMetadataSchema;
    },
    get getMetadataSchemaForTask () {
        return getMetadataSchemaForTask;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _model = require("./model");
const objectId = _zod.z.instanceof(_bson.ObjectId);
const BulkFeedbackMetadataSchema = _zod.z.object({
    authorId: _zod.z.string(),
    total: _zod.z.number(),
    counts: _zod.z.object({
        created: _zod.z.number(),
        skipped: _zod.z.number(),
        failed: _zod.z.number()
    }),
    failed: _zod.z.array(_zod.z.object({
        subjectId: _zod.z.string(),
        reason: _zod.z.string()
    })).max(100)
});
const BulkFeedbackRequestMetadataSchema = _zod.z.object({
    requesterId: _zod.z.string(),
    total: _zod.z.number(),
    counts: _zod.z.object({
        created: _zod.z.number(),
        skipped: _zod.z.number(),
        failed: _zod.z.number()
    }),
    failed: _zod.z.array(_zod.z.object({
        recipientId: _zod.z.string(),
        reason: _zod.z.string()
    })).max(100)
});
const ExportCompanyMeetingsMetadataSchema = _zod.z.object({
    filters: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional(),
    sort: _zod.z.object({
        name: _zod.z.string(),
        direction: _zod.z.enum([
            "asc",
            "desc"
        ])
    }).optional(),
    timezone: _zod.z.string(),
    signedUrl: _zod.z.string().optional()
});
const ExportWorkspaceMeetingsMetadataSchema = _zod.z.object({
    workspaceId: _zod.z.string(),
    filters: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional(),
    timezone: _zod.z.string(),
    signedUrl: _zod.z.string().optional()
});
const GenerateReviewCycleInsightsMetadataSchema = _zod.z.object({
    reviewCycleId: _zod.z.string(),
    promptHash: _zod.z.string(),
    parentLogId: _zod.z.string(),
    retry: _zod.z.boolean()
});
const GenerateSurveyInsightsMetadataSchema = _zod.z.object({
    surveyId: _zod.z.string(),
    promptHash: _zod.z.string(),
    parentLogId: _zod.z.string(),
    retry: _zod.z.boolean()
});
const ProcessDocumentEmbeddingsMetadataSchema = _zod.z.object({
    documentId: _zod.z.string(),
    filename: _zod.z.string()
});
const AddSubjectsToReviewCycleMetadataSchema = _zod.z.object({
    cycleId: _zod.z.string(),
    companyId: _zod.z.string(),
    userId: _zod.z.string(),
    adminsOnly: _zod.z.boolean(),
    startDate: _zod.z.string(),
    assignments: _zod.z.array(_zod.z.record(_zod.z.string(), _zod.z.unknown())),
    userSelectionId: _zod.z.string(),
    groupId: _zod.z.string().optional()
});
/**
 * Cycle creation data stored in task metadata.
 * Matches IReviewCycleInvocationData consumed by the create-review-cycle lambda.
 */ const CycleInvocationData = _zod.z.object({
    _id: objectId,
    name: _zod.z.string(),
    creator: objectId,
    department: objectId.nullable(),
    user_selection: _zod.z.array(objectId),
    company: objectId,
    template: objectId,
    assignments: _zod.z.array(_zod.z.record(_zod.z.string(), _zod.z.unknown())),
    admins_only: _zod.z.boolean(),
    workflow: _zod.z.object({
        _id: objectId,
        name: _zod.z.string(),
        forms: _zod.z.array(_zod.z.record(_zod.z.string(), _zod.z.unknown())),
        company: objectId
    }),
    start_date: _zod.z.date(),
    easy_add_configs: _zod.z.array(objectId),
    is_automated: _zod.z.boolean().optional(),
    timezone: _zod.z.string()
});
const CreateReviewCycleMetadataSchema = _zod.z.object({
    cycleId: _zod.z.string(),
    cycleData: CycleInvocationData,
    autoflow: _zod.z.object({
        enabled: _zod.z.boolean(),
        resourceId: objectId,
        companyId: objectId
    }).passthrough().optional()
});
const RegenerateSyntheticEmailsMetadataSchema = _zod.z.object({
    companyId: _zod.z.string(),
    triggeredByUserId: _zod.z.string(),
    oldFieldId: _zod.z.string().nullable(),
    newFieldId: _zod.z.string()
});
const ExportCompetencyAssignmentsMetadataSchema = _zod.z.object({
    scope: _zod.z.enum([
        "employee",
        "team"
    ]),
    filters: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional(),
    signedUrl: _zod.z.string().optional()
});
const FieldHistoryImportErrorSchema = _zod.z.object({
    /** Physical file line number (header = 1). Omitted for file-level errors. */ rowNumber: _zod.z.number().int().positive().optional(),
    message: _zod.z.string()
});
const ImportFieldHistoryMetadataSchema = _zod.z.object({
    fileName: _zod.z.string(),
    entryCount: _zod.z.number().optional(),
    employeeCount: _zod.z.number().optional(),
    failureKind: _zod.z.enum([
        "validation",
        "system"
    ]).optional(),
    userMessage: _zod.z.string().optional(),
    errors: _zod.z.array(FieldHistoryImportErrorSchema).optional(),
    totalErrorCount: _zod.z.number().optional()
});
const ExportGoalsCsvMetadataSchema = _zod.z.object({
    signedUrl: _zod.z.string().optional()
});
const ImportCompetencyDocumentMetadataSchema = _zod.z.object({
    filename: _zod.z.string().optional(),
    phase: _zod.z.enum([
        "analyzing",
        "extracting",
        "parsing"
    ]).optional(),
    message: _zod.z.string().optional(),
    sectionsCompleted: _zod.z.number().int().optional(),
    sectionsTotal: _zod.z.number().int().optional(),
    result: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional()
});
const getMetadataSchemaForTask = (taskName)=>{
    switch(taskName){
        case _model.ASYNC_TASK_NAMES.BULK_FEEDBACK:
            return BulkFeedbackMetadataSchema;
        case _model.ASYNC_TASK_NAMES.BULK_FEEDBACK_REQUEST:
            return BulkFeedbackRequestMetadataSchema;
        case _model.ASYNC_TASK_NAMES.EXPORT_COMPANY_MEETINGS_CSV:
            return ExportCompanyMeetingsMetadataSchema;
        case _model.ASYNC_TASK_NAMES.EXPORT_WORKSPACE_MEETINGS_CSV:
            return ExportWorkspaceMeetingsMetadataSchema;
        case _model.ASYNC_TASK_NAMES.GENERATE_REVIEW_CYCLE_INSIGHTS:
            return GenerateReviewCycleInsightsMetadataSchema;
        case _model.ASYNC_TASK_NAMES.GENERATE_SURVEY_INSIGHTS:
            return GenerateSurveyInsightsMetadataSchema;
        case _model.ASYNC_TASK_NAMES.PROCESS_DOCUMENT_EMBEDDINGS:
            return ProcessDocumentEmbeddingsMetadataSchema;
        case _model.ASYNC_TASK_NAMES.ADD_SUBJECTS_TO_REVIEW_CYCLE:
            return AddSubjectsToReviewCycleMetadataSchema;
        case _model.ASYNC_TASK_NAMES.CREATE_REVIEW_CYCLE:
            return CreateReviewCycleMetadataSchema;
        case _model.ASYNC_TASK_NAMES.REGENERATE_SYNTHETIC_EMAILS:
            return RegenerateSyntheticEmailsMetadataSchema;
        case _model.ASYNC_TASK_NAMES.EXPORT_COMPETENCY_ASSIGNMENTS_CSV:
            return ExportCompetencyAssignmentsMetadataSchema;
        case _model.ASYNC_TASK_NAMES.EXPORT_GOALS_CSV:
            return ExportGoalsCsvMetadataSchema;
        case _model.ASYNC_TASK_NAMES.IMPORT_FIELD_HISTORY:
            return ImportFieldHistoryMetadataSchema;
        case _model.ASYNC_TASK_NAMES.IMPORT_COMPETENCY_DOCUMENT:
            return ImportCompetencyDocumentMetadataSchema;
        default:
            // Exhaustiveness check
            const _exhaustive = taskName;
            throw new Error(`Unknown task name: ${_exhaustive}`);
    }
};
